import {Card, Col, Image} from "antd";
import dummy from "../../../../assets/image/dummy_obj.png";

const PlatformDownloadCard = (props) => {
    const {data} = props;

    const language = localStorage.getItem("language");

    const platformDisplayName =
        data?.displayNameLanguage?.find((v) => v?.language === language)?.label ??
        data?.displayNameLanguage?.find((v) => v?.language === "en")?.label ??
        data?.displayName;

    return (
        <a href={data?.link} target={"_blank"}>
            <Card className={"platformDownloadCard"}>
                <Col span={24} className={"text-center"}>
                    <Image
                        width={115}
                        height={115}
                        src={data?.icon ? data?.icon : data?.defaultIcon ? data?.defaultIcon : dummy}
                        style={{objectFit: "cover"}}
                        preview={false}
                    />
                    <h6 className={"mt-6"}>{platformDisplayName}</h6>
                </Col>
            </Card>
        </a>
    );
};

export default PlatformDownloadCard;
